<template>
    <eventi-view-component :jsonData="jsonData" :pathResource="pathResource" :pathResourceFirma="pathResourceFirma" :utente="utente" :titoloEvento="titoloEvento" :linkPrintData="linkPrintData">
        <template slot="tab-content-event">
            <elettrostimolatore-view-component :idEvento="id"></elettrostimolatore-view-component>
        </template>
    </eventi-view-component>
</template>
<script>
import UtilityMixins from "../../../../../utility/UtilityMixin";
import EventiMixins from "../../../utility/mixins/EventiMixins";
import ElettrostimolatoreViewComponent from "./ElettrostimolatoreViewComponent.vue";
import EventiViewComponent from "../../../base/components/EventiViewComponent.vue";

export default {
    mixins: [UtilityMixins, EventiMixins],
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    components: { ElettrostimolatoreViewComponent, EventiViewComponent },
    data() {
        return {
            linkback: null,
            linkedit: null,
            jsonData: {},
            titoloEvento: this.getLabelTraduora("patient.cardiology.lblElectroStimulator"),
            pathResourceFirma: "/cardioelettrostimolatori",
            pathResource: "/cardioelettrostimolatori",
            tabIndex: 0,
            id: null,
            pathRestValidation: "/validation",
            isThisFirmato: false,
            showModalLoading: false,
            linkPrintData: null,
        };
    },
    computed: {
        idPaziente() {
            return this.$route.query.idPaziente;
        },
        linkPatient() {
            return EventiMixins.getLinkPatient(this.utente, this.idPaziente);
        },
    },
    mounted() {
        let me = this;
        me.jsonData.idPaziente = this.$route.query.idPaziente;
        me.id = this.$route.params.id;
    },
    methods: {
        updateStatoFirma(firmato) {
            console.log(firmato);
        },
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
            me.linkPrintData = "/pazienteeventi/print/" + me.jsonData.id;
        },
    },
};
</script>
